import localeData from '../helpers/login.lang'
import {errorMessages, errorMessagesList, loginModes} from '../helpers/login.data'
import {isModeOneOf} from '../login.helper'

const language = 'en'
const locale = localeData[language]
const {
  createNewPassword, normal, renewExpiredPassword, tfaCode
} = loginModes
const {USER_PENALIZED, CODE_SENDING_BLOCKED} = errorMessages

export const isErrorMessage = ({codeSendMessage}) => errorMessagesList.includes(codeSendMessage)

export const prodWarning = ({mode}) => (
  (mode === createNewPassword)
    ? locale.prodNewAccountWarning()
    : locale.prodLoginWarning()
)

export const checkIfAuthNotificationIsVisible = ({mode, hasAuthFailed, authFailedTimes}) => (
  (mode === normal) && hasAuthFailed && (authFailedTimes < 5)
)

export const wasTFACodeSent = ({mode, codeSendMessage}) => (
  (mode === tfaCode) && !(isErrorMessage({codeSendMessage}))
)

export const didPasswordUpdateFail = ({mode, isPasswordDirty, hasAuthFailed, authFailedTimes, isConfirmPasswordDirty}) => (
  isModeOneOf({mode, modes: [createNewPassword, renewExpiredPassword]})
    && !isPasswordDirty
    && !isConfirmPasswordDirty
    && hasAuthFailed
    && (authFailedTimes < 5)
)

export const didPasswordUpdateFailRepeatedly = ({isPasswordPolicyPending, authFailedTimes}) => (
  (!isPasswordPolicyPending) && (authFailedTimes >= 5)
)

export const shouldShowProdWarning = ({isProduction, hasAuthFailed, authFailedTimes, mode, isFirstTime}) => (
  isProduction
    && (!hasAuthFailed && (authFailedTimes === 0))
    && ((mode === normal) || (mode === createNewPassword && isFirstTime))
)

export const isNotSecretCode = ({canRequestNewCode, codeSendDelay, codeSendMessage}) => (
  canRequestNewCode
    && (codeSendDelay !== 0)
    && (codeSendMessage !== USER_PENALIZED)
    && (codeSendMessage !== CODE_SENDING_BLOCKED)
)
